import type { Astrologer, PublicSettings } from '../types'

export const previewAstrologers: Astrologer[] = [
  {
    id: 'preview-acharya-ved', name: 'Acharya Ved', title: 'Vedic Astrology Expert', experience: 18,
    languages: ['Hindi', 'English'], skills: ['Vedic', 'Marriage', 'Career'], priceCall: 29, priceChat: 22,
    rating: 4.9, reviews: 2840, consultations: 12500, online: true, verified: true,
    about: 'वैदिक ज्योतिष, विवाह, करियर और जीवन-दिशा पर व्यक्तिगत मार्गदर्शन।', nextAvailable: 'अभी उपलब्ध',
  },
  {
    id: 'preview-tarot-meera', name: 'Tarot Meera', title: 'Tarot & Relationship Guide', experience: 11,
    languages: ['Hindi', 'English'], skills: ['Tarot', 'Love', 'Relationship'], priceCall: 25, priceChat: 18,
    rating: 4.8, reviews: 1940, consultations: 8200, online: true, verified: true,
    about: 'रिश्तों, भावनात्मक स्पष्टता और महत्वपूर्ण निर्णयों के लिए टैरो मार्गदर्शन।', nextAvailable: 'अभी उपलब्ध',
  },
  {
    id: 'preview-pandit-arun', name: 'Pandit Arun', title: 'Kundli & Numerology', experience: 15,
    languages: ['Hindi', 'Punjabi'], skills: ['Kundli', 'Numerology', 'Finance'], priceCall: 31, priceChat: 24,
    rating: 4.9, reviews: 2310, consultations: 9800, online: false, verified: true,
    about: 'जन्मकुंडली, अंक ज्योतिष और आर्थिक निर्णयों पर व्यावहारिक परामर्श।', nextAvailable: 'आज 6:30 PM',
  },
  {
    id: 'preview-ritu-sharma', name: 'Ritu Sharma', title: 'Vastu & Career Specialist', experience: 9,
    languages: ['Hindi', 'English'], skills: ['Vastu', 'Career', 'Business'], priceCall: 24, priceChat: 17,
    rating: 4.7, reviews: 1120, consultations: 6100, online: true, verified: true,
    about: 'घर, ऑफिस, करियर और व्यवसाय से जुड़े वास्तु व ज्योतिष मार्गदर्शन।', nextAvailable: 'अभी उपलब्ध',
  },
]

export const defaultSettings: PublicSettings = {
  announcementHi: 'Verified ज्योतिषी • सुरक्षित भुगतान • निजी परामर्श',
  announcementEn: 'Verified astrologers • Secure payments • Private consultation',
  heroTitleHi: 'सही समय पर, सही मार्गदर्शन',
  heroTitleEn: 'The right guidance, at the right time',
  heroSubtitleHi: 'अनुभवी और verified astrologers से निजी call, chat या video consultation बुक करें।',
  heroSubtitleEn: 'Book a private call, chat or video consultation with experienced, verified astrologers.',
  supportPhone: '+91 00000 00000',
  supportEmail: 'support@mokshm.in',
  callsEnabled: true,
  videoEnabled: true,
  chatEnabled: true,
}
